module.exports = __webpack_public_path__ + "static/media/maprint60seconds.ca9500a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/maprint60seconds.mp4
// module id = 4fae
// module chunks = 1